import { mediaData } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="text-2xl md:text-3xl font-heading text-center text-foreground-950">
            精彩视频
          </h2>
          <p className="mt-3 text-sm text-foreground-500 text-center">
            动画资讯、幕后故事与深度解析
          </p>

          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {mediaData.slice(0, 3).map((item) => (
              <div
                key={item.id}
                className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-background-900/20 group-hover:bg-background-900/10 transition-colors duration-300 flex items-center justify-center">
                    <div className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-play-fill text-2xl text-primary-600 ml-0.5"></i>
                    </div>
                  </div>
                  <span className="absolute top-3 left-3 px-2.5 py-1 text-xs font-semibold bg-secondary-500 text-background-50 rounded-full whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-6">
            {mediaData.slice(3, 5).map((item) => (
              <div
                key={item.id}
                className="group flex flex-col sm:flex-row bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative sm:w-56 aspect-[16/10] sm:aspect-auto overflow-hidden shrink-0">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-background-900/20 group-hover:bg-background-900/10 transition-colors flex items-center justify-center">
                    <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                      <i className="ri-play-fill text-xl text-primary-600 ml-0.5"></i>
                    </div>
                  </div>
                </div>
                <div className="p-5 flex-1 flex flex-col justify-center">
                  <span className="px-2.5 py-1 text-xs font-semibold bg-secondary-100 text-secondary-700 rounded-full self-start whitespace-nowrap mb-2">
                    {item.tag}
                  </span>
                  <h3 className="text-base font-heading text-foreground-950 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}